import { Spinner, Card, CardHeader, CardBody } from "@heroui/react";
import React from "react";
import { useTranslation } from "react-i18next";

import { OrgMemberList } from "@wc/domain/org-membership";
import { useOrg, OrgInfo } from "@wc/domain/organizations";
import SeeMoreLink from "@wc/ui/components/see-more-link";
import usePageTitle from "@wc/ui/hooks/page-title";

/**
 * @returns {React.ReactElement} The internal page with access to org data
 */
export default function OrgOverview() {
  const orgData = useOrg();
  const { t } = useTranslation();

  usePageTitle(orgData.org?.displayName || "");

  if (!orgData.org) {
    return (
      <div className="mt-8 flex justify-center">
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    <div className="m-5 flex flex-col gap-4">
      <Card className="m-5">
        <CardHeader className="flex items-center justify-between">
          <h2 className="text-xl font-bold">{t("org.tab-info")}</h2>
          <SeeMoreLink url={`/orgs/${orgData.org?.id}/info`} />
        </CardHeader>
        <CardBody>
          <OrgInfo />
        </CardBody>
      </Card>
      <Card className="m-5">
        <CardHeader className="flex items-center justify-between">
          <h2 className="text-xl font-bold">{t("org.tab-members")}</h2>
          <SeeMoreLink url={`/orgs/${orgData.org?.id}/members`} />
        </CardHeader>
        <CardBody>
          <OrgMemberList />
        </CardBody>
      </Card>
    </div>
  );
}
